//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DpIcon from '../icon/Icon.vue';
import DpTooltip from '../modal/Tooltip.vue';

export default {
  name: 'DpToggle',
  components: {
    DpIcon,
    DpTooltip,
  },
  props: {
    value: { type: [Boolean, String], default: false },
    options: { type: Array, default: () => [] },
    size: { type: String, default: 'default' },
  },
  methods: {
    selectOption(selected) {
      const { value, disabled } = selected;
      if (disabled) return;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
